<template lang="html">
  <root class="admin-country-add">

    <admin-nav></admin-nav>
    <page-header name="Add country" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m6">
          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (EN)</label>
                <input type="text" v-model="country.name.en" placeholder="Qatar">
              </div>
            </div>
            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (AR)</label>
                <input type="text" v-model="country.name.ar" placeholder="دولة قطر">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Country code (ISO alpha-2)</label>
                <input type="text" v-model="country.code" placeholder="QA">
              </div>
            </div>
            <div class="col m6">
              <div class="mui-textfield">
                <label>Phone Code</label>
                <input type="text" placeholder="974" v-model="country.phone_code">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Currency</label>
                <input type="text" placeholder="QR" v-model="country.currency">
              </div>
            </div>
            <div class="col m6">
              <div class="mui-textfield">
                <label>Currency fraction digits</label>
                <input type="text" placeholder="2" v-model="country.currency_fraction_digits">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="mui-textfield">
                <label>Hotline</label>
                <input type="text" placeholder="+9876543210" v-model="country.hotline">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="file-field input-field">
                <div class="btn">
                  <span>Flag</span>
                  <input type="file" accept="image/png" @change="uploadPhoto($event)">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" placeholder=".png, 130x66px">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col m6">
          <table class="bottom-line">
            <tbody>
              <tr>
                <th>Name (en)</th>
                <td>{{country.name.en}}</td>
              </tr>
              <tr>
                <th>Name (ar)</th>
                <td>{{country.name.ar}}</td>
              </tr>
              <tr>
                <th>Country code (ISO alpha-2)</th>
                <td>{{country.code}}</td>
              </tr>
              <tr>
                <th>Phone Code</th>
                <td>{{country.phone_code}}</td>
              </tr>
              <tr>
                <th>Currency</th>
                <td>{{country.currency}}</td>
              </tr>
              <tr>
                <th>Currency fraction digits</th>
                <td>{{country.currency_fraction_digits}}</td>
              </tr>
              <tr>
                <th>Hotline</th>
                <td>{{country.hotline}}</td>
              </tr>
              <tr>
                <th>Flag</th>
                <td class="flag-preview"><img :src="flagPreview" class="flag-image"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" :disabled="isSending" @click="add">Add</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from 'firebase'
import _ from 'lodash'

export default {
  data() {
    return {
      country: {
        name: {
          en: '',
          ar: '',
        },
        code: '',
        phone_code: '',
        currency: '',
        currency_fraction_digits: '',
        hotline: '',
      },

      flag: [],
      isSending: false,
      flagPreview: '',
    }
  },

  methods: {

    // Add country
    add() {

      // All fields are required
      if (
        !this.country.name.en ||
        !this.country.name.ar ||
        !this.country.code ||
        !this.country.phone_code ||
        !this.country.currency ||
        !this.country.currency_fraction_digits ||
        !this.country.hotline ||
        !this.flag.length
      ) return Materialize.toast('All fields are required', 4000)

      // Country code length
      if (this.country.code.length != 2) return Materialize.toast('Country code must be 2 characters', 4000)

      // Currency fraction digits
      if (_.isNaN(Number(this.country.currency_fraction_digits)) || this.country.currency_fraction_digits <= 0) {
        return Materialize.toast('Currency fraction digits must be greater than zero', 4000)
      }

      this.isSending = true

      // Data
      let country = {
        [this.country.code]: {
          name: this.country.name,
          phone_code: this.country.phone_code,
          currency: this.country.currency,
          currency_fraction_digits: Number(Number(this.country.currency_fraction_digits).toFixed()),
          hotline: this.country.hotline,
        },
      }

      // Check country existance
      this.collectCountries()
        .then( countries => {
          if (countries.includes(this.country.code)) {
            Materialize.toast('Country already exist', 4000)
            this.isSending = false
            return
          }

          // Push
          firebase.database()
            .ref('countries')
            .update(country)
            .then( countrySnap => {
              let loop = 1

              // Upload photos
              for (let flag of this.flag) {

                firebase.storage()
                  .ref('flag/' + this.country.code + '.png')
                  .put(flag.file)
                  .then( flagSnap => {
                    loop--

                    // End loop
                    if (!loop) {
                      Materialize.toast('Added', 4000)
                      this.$router.push({ name: 'Countries' })
                    }

                  })
              }
            })
        })
        .catch( error => { return })
    },

    // Upload display photo
    uploadPhoto(event) {

      // Collect photo
      let photo = event.target.files || event.dataTransfer.files

      // Validate
      if (!photo) {
        Materialize.toast('Invalid image', 4000)
        return
      }

      var reader = new FileReader()
      reader.onload = e => {
        this.flagPreview = e.target.result
      }
      reader.readAsDataURL(photo[0])

      // Push
      this.flag.push({ file: photo[0] })
    },

    // Collect counties
    collectCountries() {
      return new Promise( (resolve, reject) => {
        firebase.database()
          .ref('countries')
          .once('value')
          .then( countriesSnap => {
            let countries = []

            countriesSnap.forEach( countrySnap => {
              countries.push(countrySnap.key)
            })

            resolve(countries)
          })
      })
    }
  }
}
</script>

<style lang="scss">
.admin-country-add {
  .flag-preview {
    padding: 0;

    .flag-image {
      height: 22px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/CountryAdd.vue